import {BackHandOutlined, Delete, Edit, GrassOutlined, KeyboardBackspace} from '@mui/icons-material';
import {Alert, Box, Button, Chip, Divider, IconButton, Typography} from '@mui/material';
import React, {useCallback, useEffect, useRef, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom';
import {routes} from '../routes';
import {useTracks} from '../../hooks/useTracks';
import {findIndex, get, isEmpty, isNull, isNumber, toNumber} from 'lodash';
import {Ttrack, trackSurface} from '../../shared/types/tracks.type';
import TrackViewSkeleton from '../../components/tracks/TrackViewSkeleton';
import {t} from 'i18next';
import {LoadingButton} from '@mui/lab';
import {hands} from '../../enums/trackGroup.enums';
import Map from '../../components/tracks/Map';
import {LatLng, getGeocode, getLatLng} from 'use-places-autocomplete';
import FinishLineForm from '../../components/tracks/FinishLineForm';
import {TFinishLine} from '../../shared/types/finishLine.type';
import {useDispatch, useSelector} from 'react-redux';
import {setTrackNameItemToEdit, setTrackNameModal, setTrackNameToDuplicate} from '../../store/reducers/modal.reducer';
import {useQuery, useQueryClient} from 'react-query';
import {useAuth} from '../../hooks/useAuth';
import {RootState} from '../../store';
import {TUser} from '../../shared/types/user.type';
import CheckPointsForm from '../../components/tracks/CheckPointsForm';
import {toast} from 'react-toastify';
import {TCheckPoint} from '../../shared/types/checkPoint.type';
import DeleteModal from '../../components/modals/DeleteModal';
import Error from '../../components/global/Error';
import {Icon} from '@iconify/react';
import {useMap} from '../../hooks/useMap';
import {useCheckpoints} from '../../hooks/useCheckpoints';
import {FlCpMap} from '../../components/tracks/FlCpMap';

const GAP = 0.0001

export type MapForwardRefType = {
    updateMarker: (lats: Partial<TFinishLine>) => void
}

export type MapRefProps = {
    getCenter: () => {
        lat: number;
        lng: number;
    } | undefined,
    getAdressByPos: (lat: number, lng: number) => Promise<string | null>
}

function TrackView() {
    let {id} = useParams();
    const auth = useSelector<RootState>(state => state.user.user) as TUser | null
    const {getCoordinatesThirdPointOfTriangle} = useMap()

    const {
        getTrackById,
        isTrackLoading,
        deleteTrack,
        isDeleting,
        isDeleted,
        getTrackSurfaces,
        updateTrack,
        isUpdating,
        deleteFinishLine: deleteFl,
        isDeletingFL
    } = useTracks(false, auth?.id)
    const [item, setItem] = useState<Ttrack | null>(null)
    const [openDelete, setOpenDelete] = useState(false)
    const [surfaces, setSurfaces] = useState<trackSurface[]>([])
    const [active, setActive] = useState<'FL' | 'CP' | null>(null)
    const [cords, setCords] = useState<LatLng | undefined>(undefined)
    const [lats, setLats] = useState<Partial<TFinishLine> | null>(null)
    const [fl, setFl] = useState<Partial<TFinishLine> | null>(null)
    const [checkPoints, setCheckPoints] = useState<Array<TCheckPoint>>([])
    const [adress, setAdress] = useState<string | null>(null)
    const dispatch = useDispatch()
    const mapRef = React.useRef<MapRefProps>(null);

    const {updateCheckpoint, isUpdating: isCheckPointUpdating} = useCheckpoints()
    const queryClient = useQueryClient()

    const query = useQuery(['trackName', toNumber(id)], () => getTrackById(toNumber(id)), {
        enabled: isNumber(parseInt(id ?? '')),
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    })

    useEffect(() => {
        if (query.data) {
            setItem(query.data);
        }
    }, [query.data]);

    useEffect(() => {
        getTrackSurfaces()
            .then(response => {
                setSurfaces(response)
            }).catch(err => {
            console.error('failed to load track surfaces');
        })
    }, [])

    useEffect(() => {
        if (!item?.address) return

        setAdress(item?.address ?? null)

    }, [item?.address])


    useEffect(() => {
        if (adress) {
            (async () => {
                try {
                    let res = await getGeocode({address: adress})
                    let lat = res[0].geometry.location.lat()
                    let lng = res[0].geometry.location.lng()
                    setCords({lat, lng})
                } catch (error) {
                    toast("Couldn't find location", {type: 'error'})
                }

            })()
        }
    }, [adress])


    useEffect(() => {
        if (item?.finish_line) {

            setLats({
                latitude_a: item.finish_line?.latitude_a,
                longitude_a: item.finish_line?.longitude_a,
                latitude_b: item.finish_line?.latitude_b,
                longitude_b: item.finish_line?.longitude_b
            })
            setFl({
                latitude_a: item.finish_line?.latitude_a,
                longitude_a: item.finish_line?.longitude_a,
                latitude_b: item.finish_line?.latitude_b,
                longitude_b: item.finish_line?.longitude_b
            })
            return
        } else {
            setFl(null)
            setLats(null)
        }
    }, [item?.finish_line])


    useEffect(() => {
        setCheckPoints(item?.checkpoints ?? [])
    }, [item?.checkpoints])

    const initLats = useCallback(async () => {

        let centerOfMap = mapRef.current?.getCenter()


        console.log({centerOfMap});


        if (centerOfMap) {
            setLats({
                latitude_a: centerOfMap.lat,
                longitude_a: centerOfMap.lng,
                latitude_b: centerOfMap.lat + GAP,
                longitude_b: centerOfMap.lng + GAP
            })

            let newAdress = await mapRef.current?.getAdressByPos(centerOfMap.lat, centerOfMap.lng)
            console.log({newAdress});

            if (newAdress) {
                setAdress(newAdress)
            }


        } else {
            setLats({
                latitude_a: cords?.lat ?? 0,
                longitude_a: cords?.lng ?? 0,
                latitude_b: cords?.lat ?? 0 + GAP,
                longitude_b: cords?.lng ?? 0 + GAP
            })
        }
    }, [cords])

    const navigate = useNavigate()

    const backToTracks = () => {
        navigate(routes.DASHBOARD_ROUTES.TRACKS)
    }

    useEffect(() => {
        if (isDeleted) {
            backToTracks()
        }
    }, [isDeleted])

    //Get Selected Surface
    const getSurface = () => {
        if (!isEmpty(surfaces)) {
            let surface = surfaces?.find(e => get(e, '@id') === get(item, 'track_surface[@id]'))
            if (surface) {
                return surface.translation_key?.replaceAll('.', ':') ?? ''
            } else {
                return ''
            }

        } else {
            return ''
        }

    }
    //Get selected hand turn
    const getHandTurn = () => {
        let hand = hands.find(e => e.value === item?.hand_turn)
        if (hand) {
            return hand.key
        } else {
            return ''
        }
    }

    const deleteFinishLine = () => {
        let id = item?.finish_line?.id
        if (id) {
            deleteFl(id)
                .then(async (result) => {
                    await query.refetch()
                }).catch(err => {
                toast(t('error:generic'))
            })

        }
        setFl(null)
        setLats(null)
    }
    const updateTrackFl = useCallback((fl: TFinishLine, add: string | null) => {

        updateTrack({id: toNumber(item?.id), finish_line: get(fl, '@id', ""), address: add ? add : adress ?? ''})
            .then(async (result) => {
                result && setItem(result)
               await query.refetch()

            }).catch(err => {

        })
    }, [item?.id, adress])


    const editTrack = () => {
        dispatch(setTrackNameModal(true))
        if (item) dispatch(setTrackNameItemToEdit(item))

    }

    const onFinishLinePosChanged = useCallback((positions: google.maps.LatLngLiteral[]) => {
        setActive('FL')
        setLats({
            latitude_a: positions[0].lat,
            longitude_a: positions[0].lng,
            latitude_b: positions[1].lat,
            longitude_b: positions[1].lng
        })
        setFl({
            latitude_a: positions[0].lat,
            longitude_a: positions[0].lng,
            latitude_b: positions[1].lat,
            longitude_b: positions[1].lng
        })
    }, [])

    const onCheckPointPosChanged = (positions: google.maps.LatLngLiteral[], id: number) => {
        setActive('CP')
        let item = checkPoints?.find(e => e.id === id)
        let index = checkPoints?.findIndex(e => e.id === id)

        if (item && isNumber(index)) {
            item.latitude_a = positions[0].lat
            item.latitude_b = positions[1].lat
            item.longitude_a = positions[0].lng
            item.longitude_b = positions[1].lng
            let filtered = checkPoints && checkPoints.filter((e, i) => e.id !== id)

            filtered?.push(item)

            setCheckPoints(filtered)
        }


    }

    const updateMapFinishLineMarkers = (l: Partial<TFinishLine>) => {
        setLats(l)
        setFl(l)
    }

    const duplicateTrack = () => {
        dispatch(setTrackNameToDuplicate(item))
        dispatch(setTrackNameModal(true))
    }

    const updateCp = (cp: TCheckPoint) => {

        let temp = [...checkPoints]

        var index = findIndex(temp, {id: cp.id});

        // Replace item at index using native splice
        temp.splice(index, 1, cp);

        setCheckPoints(temp)

    }


    const saveCheckpoints = () => {
        if (!isEmpty(checkPoints)) {

            let promises: any[] = []

            checkPoints.forEach(cp => {
                let latlngc = getCoordinatesThirdPointOfTriangle([
                    {lat: toNumber(cp.latitude_a), lng: toNumber(cp.longitude_a)},
                    {lat: toNumber(cp.latitude_b), lng: toNumber(cp.longitude_b)},
                ], cp.direction).toJSON()

                promises.push(updateCheckpoint({...cp, latitude_c: latlngc.lat, longitude_c: latlngc.lng}))
            })

            Promise.all(promises).then((values) => {
                if (item?.address !== adress) {
                    updateTrack({id: toNumber(item?.id), address: adress ?? ''})
                }
                queryClient.refetchQueries(['trackName', item?.id])
                toast(t('rights:success'), {type: 'success'})
            }).catch(err => {
                toast(t('error:generic'), {type: 'error'})
            });


        }
    }


    return query.isLoading ? <TrackViewSkeleton></TrackViewSkeleton> : (
        <Box>
            <Divider sx={{my: 2}}></Divider>
            <Box display={'flex'} justifyContent={'space-between'} flexWrap={'wrap'} alignItems={'center'}>
                <Box display={'flex'} gap={2} alignItems={'center'}>
                    <IconButton onClick={backToTracks}>
                        <KeyboardBackspace></KeyboardBackspace>
                    </IconButton>
                    <Typography variant='subtitle2'>{item?.name}</Typography>
                </Box>
                <Box display={'flex'} gap={1} flexWrap={'wrap'}>
                    <Button disableElevation variant={active === 'FL' ? 'contained' : 'outlined'}
                            onClick={() => active === 'FL' ? setActive(null) : setActive('FL')}
                            color='primary'>{t('tracks:finishLine')}</Button>
                    <Button disableElevation variant={active === 'CP' ? 'contained' : 'outlined'}
                            onClick={() => active === 'CP' ? setActive(null) : setActive('CP')}
                            color='primary'>{t('tracks:checkpoints')}</Button>
                    <Button variant='outlined' onClick={editTrack} startIcon={<Edit></Edit>}
                            color='warning'>{t('button:edit')}</Button>
                    <Button variant='outlined' onClick={duplicateTrack}
                            startIcon={<Icon icon='octicon:duplicate-24'></Icon>}
                            color='warning'>{t('tracks:duplicate')}</Button>


                    <LoadingButton variant='outlined' loading={isDeleting} onClick={() => setOpenDelete(true)}
                                   startIcon={<Delete></Delete>} color='error'>{t('tracks:deleteTrack')}</LoadingButton>
                    {/*Delete Modal*/}
                    <DeleteModal title='tracks:deleteTrack' subtitle='tracks:deleteTrackMessage' open={openDelete}
                                 handleClose={() => setOpenDelete(false)}
                                 isDeleting={isDeleting}
                                 onDelete={() => deleteTrack(toNumber(id))}
                    ></DeleteModal>

                </Box>
            </Box>
            <Box display={'flex'} gap={2} sx={{my: 3}}>
                {getSurface() && <Chip sx={{display: 'flex', alignItems: 'center'}} variant='outlined' color='success'
                                       icon={<GrassOutlined></GrassOutlined>} label={t(getSurface())}></Chip>}
                {getHandTurn() && <Chip sx={{display: 'flex', alignItems: 'center'}} variant='outlined'
                                        icon={<BackHandOutlined></BackHandOutlined>} label={t(getHandTurn())}></Chip>}
            </Box>
            {/* If finish line button activated */}
            {active === 'FL' &&
                <>
                    <Alert severity='info' sx={{my: 2}}>
                        {t('tracks:explanationMoveMarkers')}
                    </Alert>

                    <FinishLineForm onAdressChange={(adress) => {
                        setAdress(adress)
                    }} adress={adress} finishLine={item?.finish_line} initLats={initLats} deleting={isDeletingFL}
                                    deleteFinishLine={deleteFinishLine} lats={lats}
                                    onLatsChanged={l => updateMapFinishLineMarkers(l)}
                                    onFlSaved={updateTrackFl}></FinishLineForm>
                </>
            }
            {/* If checkpoints button activated */}
            {active === 'CP' &&
                <>

                    <CheckPointsForm isSavingCps={isCheckPointUpdating} saveCheckpoints={saveCheckpoints}
                                     updateCp={updateCp} cords={cords} onAdressChange={(adress) => {
                        setAdress(adress)
                    }} adress={item?.address} track={item} checkpoints={checkPoints} finishLine={fl}></CheckPointsForm>
                </>
            }
            <FlCpMap onCheckPointPosChanged={onCheckPointPosChanged} onFinishLinePosChanged={onFinishLinePosChanged}
                     adressCenter={cords} finishLine={fl} checkPoints={checkPoints} ref={mapRef}></FlCpMap>
        </Box>

    )
}

export default TrackView